"use client"

import { useShortcut } from "@remcostoeten/use-shortcut"
import { useTheme } from "next-themes"

type ViewTransitionDocument = Document & {
    startViewTransition?: (cb: () => void) => void
}

export function GlobalThemeShortcut() {
    const { theme, setTheme, systemTheme } = useTheme()
    const $ = useShortcut()

    $.alt.key("t").on(() => {
        const toggleTheme = () => {
            const currentTheme = theme === "system" ? systemTheme : theme
            const newTheme = currentTheme === "dark" ? "light" : "dark"
            setTheme(newTheme)
        }

        const vtDocument = document as ViewTransitionDocument
        if (!vtDocument.startViewTransition || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            toggleTheme()
            return
        }

        vtDocument.startViewTransition(() => toggleTheme())
    })

    return null
}
